import React from 'react';

import { GutterType } from '../variables';
import styled, { css } from 'styled-components';

type ListLayoutCellProps = {
    children: React.ReactNode;
    marginTop?: GutterType;
    marginBottom?: GutterType;
    marginLeft?: GutterType;
    marginRight?: GutterType;
    zIndex?: number;
    className?: string;
};

export const ListLayoutCell = styled('div').withConfig({ shouldForwardProp: (prop) => ['children'].includes(prop) })<
    Partial<ListLayoutCellProps>
>`
    &&& {
        display: flex;
        position: relative;
        z-index: ${(props) => props.zIndex ?? 100};
        margin-top: ${(props) => props.marginTop ?? 0}px;
        margin-bottom: ${(props) => props.marginBottom ?? 0}px;
        margin-left: ${(props) => props.marginLeft ?? 0}px;
        margin-right: ${(props) => props.marginRight ?? 0}px;
    }
`;
